// Canonical onboarding step order — the single source of truth shared by
// OnboardingContext (resume/progress logic) and ConversationalOnboarding
// (render order). Mirrored in the backend (ONBOARDING_STEP_IDS in
// app/routes/profile.py) and the mobile client (STEP_IDS in lib/constants.ts).
//
// Steps are tracked by NAME, not index, so the branched archetype flows
// (ai-coached / self-led / coach) never depend on a fixed step count. The
// backend stays branch-agnostic; clients own which steps a given archetype
// actually renders.
export const STEP_IDS = [
  "intro",
  "username",
  "approach",
  // (No consent step: every acceptance is given once, at sign-up; an account
  // without one is asked by consent/TermsModal.jsx.)
  // Strava connects EARLY (before pricing/mode) so its background sync has the
  // longest possible head start populating strava_activities before the
  // interview reads it — the coach can then open with the athlete's real
  // volume/sports instead of asking cold.
  "strava",
  "pricing",
  "mode",
  // Full-screen data-gathering wizard (replaces the old single agentic
  // `interview` step) — each writes its own field(s) directly, no chat turn.
  // races/hours/rhythm are conditionally skipped (no race goal; self_led)
  // by the step component itself calling completeStep and advancing past
  // them, same pattern a coach already uses to skip past `interview` today.
  "goal",
  "races",
  "sports",
  "equipment",
  "hours",
  "availability",
  "rhythm",
  "experience",
  "injuries",
  // Final step: coach_led opens a single recap chat then builds the plan;
  // self_led completes silently with no chat. Same name/position as before.
  "summary",
];

// 0-based position of a step name in canonical order, or -1 if unknown.
export const stepIndex = (id) => STEP_IDS.indexOf(id);

// Highest canonical index among a set of completed step names (-1 if none).
export const maxStepIndex = (steps = []) =>
  steps.reduce((max, id) => Math.max(max, stepIndex(id)), -1);

// The resume point: first step in canonical order not yet completed. Falls
// back to the last step when everything is done.
export const firstIncompleteStep = (completed = []) =>
  STEP_IDS.find((id) => !completed.includes(id)) ?? STEP_IDS[STEP_IDS.length - 1];
